module.exports = __webpack_public_path__ + "img/header-logo-min.f395f262.jpg";